import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';
import { AnimationDirection, AnimationDirectionType } from '../menuAnimations.util';
import { Link } from '../../../../partials/link/Link';
import { baseUnit } from '../../../../../theming/baseUnitDefinition';
import { reducedLogoHeightFactor } from '../header.utils';

export interface LogoDataProps {
  logoImageLarge?: string | null;
  logoImageSmall?: string | null;
  svgLarge: string;
  svgSmall: string;
  svgLargeViewBox: string;
  svgSmallViewBox: string;
  alt: string;
  href: string;
}

interface LogoLogicProps {
  logoHeightInSmallScreen: number;
  logoHeightInMediumScreen: number;
  logoHeightInLargeScreen: number;
  menuAnimation?: AnimationDirectionType;
  reduceHeightAnimationDuration?: number;
}

type LogoProps = LogoDataProps & LogoLogicProps;

const getLogoStyle = (logoHeightInLargeScreen: number, logoHeightInMediumScreen: number, logoHeightInSmallScreen: number, menuAnimation: AnimationDirectionType, reduceHeightAnimationDuration: number) => {
  return StyleSheet.create({
    base: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${logoHeightInLargeScreen * baseUnit * reducedLogoHeightFactor}px` : `${logoHeightInLargeScreen * baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${logoHeightInMediumScreen * baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${logoHeightInSmallScreen * baseUnit}px`,
      },
      alignItems: 'center',
      transition: `${reduceHeightAnimationDuration}ms`,
    },
    largeSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none',
      },
    },
    smallSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex',
      },
    },
    image: {
      height: '100%',
    },
  });
};

const getImageResource = (svg: string, image: string | undefined | null) => {
  if (typeof image === 'string') {
    return image;
  }

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const Logo: React.FunctionComponent<LogoProps> = props => {
  const { href, alt, svgLarge, svgSmall, logoHeightInLargeScreen, logoHeightInMediumScreen, logoHeightInSmallScreen, menuAnimation = AnimationDirection.NONE, reduceHeightAnimationDuration = 0, logoImageLarge, logoImageSmall } = props;
  const style = getLogoStyle(logoHeightInLargeScreen, logoHeightInMediumScreen, logoHeightInSmallScreen, menuAnimation, reduceHeightAnimationDuration);

  return (
    <React.Fragment>
      <Link className={css(style.largeSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={getImageResource(svgLarge, logoImageLarge)} />
      </Link>
      <Link className={css(style.smallSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={getImageResource(svgSmall, logoImageSmall)} />
      </Link>
    </React.Fragment>
  );
};
